import React, { useState } from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, ListGroupItem } from 'reactstrap';
import { t } from 'i18next';
import axios from 'axios';
import { BACKEND_URL_LOG, BACKEND_URL_DOC } from '../../../config/const';
import './PapperStyle.css'
const Supprimer = ({ ItemId, name }) => {
    const [open, setOpen] = useState(false);
    const [openDelSucc, setOpenDelSucc] = useState(false);
    const [openDelError, setOpenDelError] = useState(false);

    const handleToggle = () => setOpen(!open);
    const handleToggleDelSucc = () => setOpenDelSucc(!openDelSucc);
    const handleToggleDelError = () => setOpenDelError(!openDelError);


    const deleteItem = async () => {
            const config = {
                headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
                
            };
           
    const data ={ idTeam: ItemId }
            try {
                // Premier appel API
                await axios.post(`${BACKEND_URL_LOG}deleteTeam`,data, config);
    
                // Deuxième appel API
                await axios.post(`${BACKEND_URL_DOC}deleteTeam`,  data, config);
    
                setOpen(false);
                setOpenDelSucc(true);
            } catch (error) {
                setOpen(false);
                setOpenDelError(true);
            }
        };

    return (
        <>
            <button  className="btn btn-primary ContactBtn"  onClick={handleToggle}>{t('DELETE')}</button>
            
            <Modal isOpen={open} toggle={handleToggle} centered>
                <ModalHeader toggle={handleToggle}>{t('DELETE')}</ModalHeader>
                <ModalBody>
                    {t('MessageDeletedRole')} {name}
                </ModalBody>
                <ModalFooter>
                    <button className="btn btn-primary" onClick={handleToggle}>{t('cancel')}</button>
                    <button className="btn btn-primary" onClick={deleteItem}>{t('DELETE')}</button>
                </ModalFooter>
            </Modal>

            <Modal isOpen={openDelSucc} toggle={handleToggleDelSucc} centered>
                <ModalBody className="text-center">
                    <ListGroupItem className="text-success">
                        <i className="bi bi-check-circle-fill"></i> {name} {t('Deletedsuccessfully')}
                    </ListGroupItem>
                </ModalBody>
                <ModalFooter>
                    <button className="btn btn-primary" onClick={() => window.location.reload()}>{t('Ok')}</button>
                </ModalFooter>
            </Modal>

            <Modal isOpen={openDelError} toggle={handleToggleDelError} centered>
                <ModalBody className="text-center">
                    <ListGroupItem className="text-danger">
                        <i className="bi bi-x-circle-fill"></i> {name} {t('DeletefailedRole')}
                    </ListGroupItem>
                </ModalBody>
                <ModalFooter>
                    <button className="btn btn-primary" onClick={handleToggleDelError}>{t('Ok')}</button>
                </ModalFooter>
            </Modal>
        </>
    );
};

export default Supprimer;